import { Presence } from 'phoenix';
import { merge } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { ChannelWithPresence, fromChannel } from '@recruitee/websocket';

export type AdminsPresencesMap = Record<
  string,
  { metas: Array<{ online_at: number; typed_note?: { reply_to_id?: number } }> }
>;

export const syncPresence = <T extends ChannelWithPresence>(channel: T) => {
  let presences: AdminsPresencesMap = {};
  return merge(
    fromChannel(channel, 'presence_state').pipe(
      map(
        (state): AdminsPresencesMap => Presence.syncState(presences, state, undefined, undefined),
      ),
    ),
    fromChannel(channel, 'presence_diff').pipe(
      map((diff): AdminsPresencesMap => Presence.syncDiff(presences, diff, undefined, undefined)),
    ),
  ).pipe(tap(presence => (presences = presence)));
};
